module.exports = __webpack_public_path__ + "img/tie.299b5188.png";